// pages/SignIn.tsx
import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
//import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

export default function SignIn() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            navigate('/cc');
        }, 1000);
    };

    const handleGoogleSuccess = async (credentialResponse: any) => {
        try {
            const res = await fetch('/auth/google', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: credentialResponse.credential }),
            });
            const data = await res.json();
            //console.log('Google login success:', data);
            navigate('/cc');
        } catch (error) {
            console.error('Google login error:', error);
        }
    };

    const handleFacebookResponse = async (response: any) => {
        try {
            const res = await fetch('/auth/facebook', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accessToken: response.accessToken }),
            });
            const data = await res.json();
            console.log('Facebook login success:', data);
            navigate('/cc');
        } catch (error) {
            console.error('Facebook login error:', error);
        }
    };

    return (
        <Container
            maxWidth="sm"
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Invisible wrapper instead of Paper */}
            <Box sx={{ p: 4, width: '100%' }}>
                <Typography variant="h5" align="center" fontWeight="bold" mb={1}>
                    Sign In
                </Typography>
                <Typography variant="body2" align="center" color="text.secondary" mb={3}>
                    Please log in to continue
                </Typography>

                <Box display="flex" gap={2} justifyContent="center" mb={2}>
                    {/* Facebook */}
                    <FacebookLogin
                        appId={import.meta.env.VITE_FACEBOOK_APP_ID || ''}
                        autoLoad={false}
                        fields="name,email,picture"
                        callback={handleFacebookResponse}
                        render={(renderProps: any) => (
                            <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<FacebookIcon />}
                                sx={{ textTransform: 'none' }}
                                onClick={renderProps.onClick}
                            >
                                Facebook
                            </Button>
                        )}
                    />
                    {/* Google */}
                    <Box flex={1} display="flex" justifyContent="center">
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={() => console.log('Google Login Failed')}
                            type="standard"
                            theme="outline"
                            shape="rectangular"
                            text="signin_with"
                        />
                    </Box>
                </Box>

                <Typography align="center" color="text.secondary" mb={1}>
                    Or
                </Typography>

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={form.email}
                        onChange={handleChange}
                        margin="normal"
                        required
                    />
                    <TextField
                        fullWidth
                        label="Password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={form.password}
                        onChange={handleChange}
                        margin="normal"
                        required
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Typography
                        variant="body2"
                        align="right"
                        color="primary"
                        sx={{ mt: 1, cursor: 'pointer' }}
                    >
                        Forgot Password?
                    </Typography>

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        sx={{ mt: 3, borderRadius: 3 }}
                        disabled={loading}
                    >
                        {loading ? 'Logging in...' : 'Log In'}
                    </Button>
                </form>

                <Typography align="center" sx={{ mt: 2 }}>
                    Don’t have an account?{' '}
                    <Button
                        variant="text"
                        onClick={() => navigate('/signup')}
                        sx={{ textTransform: 'none' }}
                    >
                        Sign Up
                    </Button>
                </Typography>
            </Box>
        </Container>
    );
}
